import { checkIcon } from '@progress/kendo-svg-icons';
import { SessionModel } from './../../../models/session.model';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { EnumService } from 'app/core/services/enum.service';
import { EnumModel } from 'app/models/enum.model';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { PropertyFileModel } from 'app/models/property-file.model';
import { PropertyFilesService } from 'app/services/property-files.service';
import { MembershipService } from 'app/core/services/membership.service';

@Component({
  standalone: false,
  selector: 'app-property-file',
  templateUrl: './property-file.component.html',
  styleUrls: ['./property-file.component.scss']
})
export class PropertyFileComponent extends NexusComponent {
  checkIcon = checkIcon;

  public property_file_model: PropertyFileModel = new PropertyFileModel();
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public form = new UntypedFormGroup({
    name: this.CreateRequiredFormControl(),
    notes: this.CreateRequiredFormControl(),
  });
  session: SessionModel;

  constructor(private route: ActivatedRoute, private router: Router, private property_files_service: PropertyFilesService,private membership:MembershipService) {
    super();
    this.event_service.on('session-start', (model) => {
      this.session = model;
    });
    this.event_service.on('session-end', () => {
      this.session = null;
    });

  }

  ngOnInit() {
    super.ngOnInit();

    this.membership.GetSession().subscribe(
      data => {
        this.session = data;
      },
      error => {
        this.session = null;
      });

    this.route.data.subscribe(({ property_file_model }) => {
      this.property_file_model = property_file_model;
      this.form.patchValue(this.property_file_model);
    });
    this.form.valueChanges.subscribe((form_data: any) => {
      this.PopulateModelFromForm(form_data, this.property_file_model);
    });
  }

  submit() {
    this.form_result.Reset();

    this.SetFormTouched(this.form);
    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }

    this.StartSpinner();
    this.property_files_service.SavePropertyFile(this.property_file_model).subscribe(
      data => {
        this.property_file_model = data;
        this.form_result.Success();
        this.StopSpinner();
        this.router.navigate(['/files']);
      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      }
    );
  }
}
